export default {
	field: 'location',
	name: 'Location',
}
